import { Button, Select } from '@/components';
import Language from '@/entities/Language';
import { useState } from 'react';
import styles from './DeleteLanguage.module.css';

interface DeleteLanguageProps {
  languages: Language[];
  languageDeleted: (language: Language) => void;
}

const DeleteLanguage = ({
  languages = [],
  languageDeleted = () => {},
}: DeleteLanguageProps): JSX.Element => {
  const [selectedLanguage, setSelectedLanguage] = useState<
    Language | undefined
  >(undefined);
  return (
    <div className={styles.container}>
      <Select
        options={languages}
        getOptionKey={(language) => language.code}
        getOptionLabel={(language) => `${language.name} (${language.code})`}
        onChange={setSelectedLanguage}
        placeholder="Choose a language"
      />
      <Button
        label="Delete language"
        onClick={() => {
          if (selectedLanguage) {
            languageDeleted(selectedLanguage);
          }
        }}
      />
    </div>
  );
};

export default DeleteLanguage;
